export default "__VITE_ASSET__BvzVqOi5__"